// extracted by mini-css-extract-plugin
module.exports = {"label":"_3N3nl","inputGroup":"_2uERl","spinnerArrows":"bKBvP","upArrow":"_11lkb","downArrow":"_3Bjyb","disabled":"_4Irna"};